import Map from "./Map";

const Global = {
  init: () => {
    // setup global click handler
    window.addEventListener("click", Global.clickHandler);
  },

  // get elements as an array
  getElements: (selector) => {
    return Array.from(document.querySelectorAll(selector));
  },

  // close all items with aria-expanded attr
  closeAll: (list) => {
    if (list) {
      list.forEach((item) => {
        if (item.hasAttribute("aria-expanded")) {
          item.setAttribute("aria-expanded", "false");
        }

        item.classList.remove("is--expanded");

        // restore header mobile nav btn inner text
        if (item.classList.contains("header__btn")) {
          const headerBtnText = item.dataset.textOpen
            ? item.dataset.textOpen
            : "Meny";

          // inner span element
          const btnText = item.querySelector(".button__text");

          if (btnText) btnText.textContent = headerBtnText;
        }
      });
    }
  },

  // global click handler
  clickHandler: (e) => {
    const elTarget = e.target;

    // close all share dialogues
    if (!elTarget.classList.contains("btn-share")) {
      const shareBtns = Global.getElements(".btn-share");
      if (shareBtns) Global.closeAll(shareBtns);
    }

    // close sub menus
    if (
      !elTarget.closest(".menu-item-has-children") &&
      !elTarget.closest(".header__btn") &&
      !elTarget.closest(".header__nav")
    ) {
      // is clicking outside navs
      const navs = Global.getElements(
        ".header [aria-expanded='true'], .header .is--expanded"
      );
      if (navs) Global.closeAll(navs);
    }

    // card (club-pin): map location btn
    if (elTarget.closest(".button--is-location")) {
      // get current card element
      const card = elTarget.closest(".club-pin");

      if (card) {
        // get card latlng data
        const latitude = card.dataset.latitude;
        const longitude = card.dataset.longitude;

        // zoom to pin!
        Map.zoomToLocation([latitude, longitude]);
      }
    }

    // article: copy btn
    if (elTarget.closest(".button--is-copy")) {
      // get copy btn
      const copyBtn = elTarget.closest(".button--is-copy");

      if (copyBtn) {
        const artNr = copyBtn.dataset.artnr;

        if (artNr) Global.copyToClipboard(artNr);
      }
    }
  },

  copyToClipboard: async (txt) => {
    try {
      await navigator.clipboard.writeText(txt);
    } catch (error) {
      console.error(error.message);
    }
  },
};

export default Global;
